<template>
     <router-view />
</template>